import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { alertService } from 'components/Varios/alert_service'
import Cargando from 'components/Varios/Cargando'
import { ObtenerProyectosInstitucionales } from './FunctionsProyectosInstitucionales'
import CardProyectosInstitucionales from "./CardProyectosInstitucionales"
import { InformacionGeneralProyectosInstitucionales } from "./TypesProyectosInstitucionales"

type StateProyectosInstitucionales = {
    datosGenerales: InformacionGeneralProyectosInstitucionales,
    loading: boolean,
    mensajeError: string
}

export default function ProyectosInstitucionales() {

    const defaultStateProyectosInstitucionales: StateProyectosInstitucionales = {
        datosGenerales: {
            tiposAmbito: [],
            tiposFuncion: [],
            tiposTermino: [],
            estructuraorganica: [],
            periodosacademicos: [],
            unidad: "",
            idunidad: 0,
            anio: -1
        },
        loading: false,
        mensajeError: "",
    }


    const [getstateProyectosInstitucionales, setstateProyectosInstitucionales] = useState<StateProyectosInstitucionales>(defaultStateProyectosInstitucionales)

    function handleErrorInformacion(message?: string) {
        const mensaje = message ?? "Ha ocurrido un evento inesperado al intentar obtener información"
        alertService.error(mensaje)
    }

    async function GetDatosGenerales() {
        setstateProyectosInstitucionales({ ...getstateProyectosInstitucionales, loading: true });
        var respuesta = await ObtenerProyectosInstitucionales(handleErrorInformacion);
        if (respuesta.status === 200) {
            setstateProyectosInstitucionales({ ...getstateProyectosInstitucionales, datosGenerales: respuesta.dataResponse, loading: false });
        }
        else {
            setstateProyectosInstitucionales({ ...getstateProyectosInstitucionales, loading: false, mensajeError: respuesta.errorMessage ?? "" });
        }
    }


    useEffect(() => {
        GetDatosGenerales();
    }, [])


    const cardSolicitudesProyectosInstitucionales = useMemo(() => {
        const {
            tiposAmbito,
            tiposFuncion,
            tiposTermino,
            estructuraorganica,
            periodosacademicos,
            unidad,
            idunidad,
            anio,
        } = getstateProyectosInstitucionales.datosGenerales
        return (
            <CardProyectosInstitucionales
                tiposAmbito={tiposAmbito}
                tiposFuncion={tiposFuncion}
                tiposTermino={tiposTermino}
                listestructuraorganica={estructuraorganica}
                periodosacademicos={periodosacademicos}
                unidad={unidad}
                idunidad={idunidad}
                anio={anio}
            />
        )
    }, [getstateProyectosInstitucionales.datosGenerales])


    if (getstateProyectosInstitucionales.loading) {
        return <Cargando mensaje='Cargando'></Cargando>
    }
    else if (getstateProyectosInstitucionales.mensajeError !== "") {
        return (
            <div className='content'>

            </div>
        )
    }

    return (
        <div className='content'>
            <div className="titulo_seccion">
                Solicitudes para designaciones de responsabilidad en proyectos institucionales
            </div>

            {cardSolicitudesProyectosInstitucionales}

        </div>
    )
}